import React, { useRef } from 'react';
import { Input } from './Input';
import Icon from './Icons/Icon';


export const InlineInput = ({ value, label, inputFlex = 1, containerStyle = {}, labelStyle = {}, iconName = '', isInputOpen = true, isUpload = false, required, ...props }) => {
	const inputId = `${label}-${Math.random()}-input`;
  const uploadInputRef = useRef();

	const handleRefClick = () => {
		if (isUpload) uploadInputRef.current.click();
	}

	const handleUpload = (e) => {
		const files = e.current?.files || e.target?.files;
		props.onChange(files);
	}

	return (
		<div className="ds-inline-input-container" style={containerStyle} onClick={handleRefClick}>
			{label && (
				<label htmlFor={inputId} className="ds-inline-input-label" style={labelStyle}>
					{iconName && (
						<Icon name={iconName} size={24} style={{ borderRadius: '8px' }} class='ds-activity-card-icon' />
					)}
					{label}
				</label>
			)}

			{isInputOpen ? (
				<Input
					containerStyle={{ display: 'flex', flex: inputFlex, width: '100%' }}
					innerContainerStyle={{ width: '100%', margin: 0 }}
					inputclass={`ds-inline-input ${required ? 'ds-inline-input--required' : ''}`}
					value={value}
					required={required}
					{...props}
				/>
			) : (
				<p className="ds-inline-value" style={{ flex: inputFlex }}>{value}</p>
			)}

			{isUpload && (
				<input type="file" style={{ display: 'none' }} onChange={handleUpload} accept={props.accept ? props.accept : "image/png, image/jpeg"} multiple={props.multiple} ref={uploadInputRef} />
			)}

		</div>
	);
};
